mutation CreateMediaFolder($clientId: ID!, $folderId: ID!, $newFolderName: String!) {
    createMediaFolder(clientId: $clientId, folderId: $folderId, newFolderName: $newFolderName) {
        id
    }
}
